/*eslint eqeqeq:0*/ // disabilitato il controllo sull'uguaglianza forte (continui controlli se una variabile è undefined o null)

import angular from 'angular';
import moment from 'moment';
import _ from 'lodash';

const instrumentHistoryFactory = function instrumentHistoryFactory($q, $log, $http, endPoints, NewTokenService, StorageService, $state, $rootScope, $filter, NewBackendService, ScaService, scaTypeConstants) {
        "ngInject";
      const
        ACTIVATE_FROMTO_PARSER = false,
        DEFAULT_DATE_FILTER_FORMAT = "yyyyMMdd",
        PREFIX_CASSACOMUNE = "CC",
        PREFIX_PAGHETTA = "PG",
        PREFIX_CROWDFUNDING = "CW",
        PREFIX_ANTICIPO = "AT",
        PREFIX_UNLOCK_ANTICIPO = "UN",
        PREFIX_PAGAROMANA = "PR",
        BANK_TRANSFER_LABEL = "Bank Transfer",
        //non mostrare movimenti prima del 25 marzo
        MOVEMENT_START_FROM_LIMIT = moment("25/03/2016", "DD/MM/YYYY");


      const
        DEFAULT_BANK_TRANSFER_PAGE_ELEMENTS = 30,
        DEFAULT_DATE_FROM_DAYS_SUBTRACTION = 45;

      // const getAvatarImage = function(source, prefix) {
      //   return $q(function(resolve, reject) {
      //     if (source.paymentReason === "p2p") {
      //       if (prefix == PREFIX_CROWDFUNDING) {
      //         if (source.base64ImmagineSocial != undefined) {
      //           resolve(source.base64ImmagineSocial);
      //         } else {
      //           resolve(undefined);
      //         }
      //         return;
      //       }
      //       const avatarId = source.idContactUserwalletAvatarComplex;
      //       return AvatarImageService.getAvatarImage(avatarId).then(function(result) {
      //         $log.debug(result);
      //         resolve(result.avatar);
      //       }, function(reason) {
      //         reject(reason);
      //       });
      //     } else if (prefix == PREFIX_CASSACOMUNE) {
      //       resolve(source.base64ImmagineSocial);
      //     } else if (prefix == PREFIX_PAGHETTA || prefix == PREFIX_ANTICIPO) {
      //       const avatarId = source.idContactUserwalletAvatarComplex;
      //       return AvatarImageService.getAvatarImage(avatarId).then(function(result) {
      //         $log.debug(result);
      //         resolve(result.avatar);
      //       }, function(reason) {
      //         reject(reason);
      //       });
      //     } else {
      //       if (source.base64ImmagineSocial != undefined) {
      //         resolve(source.base64ImmagineSocial);
      //       } else {
      //         resolve(undefined);
      //       }
      //     }
      //   });
      //
      // };

      const createAnticipoRecord = function(destination, source) {
        const idWallet = NewTokenService.getUserContext().idWallet;
        const isIncome = destination.isIncome;
        if (isIncome) {
          destination.title = "t.app.profilo.ricarica.movimento.record.anticipoRicevuto.da";
        } else {
          destination.title = "t.app.profilo.ricarica.movimento.record.anticipoEffettuato";
        }
        //destination.transferDescription = source.description;
        if (source.anticipoExtended) {
          const anticipoObj = source.anticipoExtended;
          const statoAnticipo = anticipoObj.stato;
          if (statoAnticipo) {
            if (statoAnticipo === 3) { // ANTICIPO RESTITUITO
              if (anticipoObj.idwalletbeneficiario == idWallet && !isIncome) { //compare tra numero e stringa
                // è un debito che ho restituito:
                destination.title = "t.app.profilo.ricarica.movimento.record.anticipoRestituito.a";
              } else if (anticipoObj.idwalletbeneficiario != idWallet && isIncome) {
                // è un credito che mi è stato restituito:
                destination.title = "t.app.profilo.ricarica.movimento.record.anticipoRestituito.da";
              }
            }
          }
        }
        destination.transferDescription = $filter("translate")(destination.title) + " " + source.contactName + " " + source.contactSurname;
        return destination;
      };

      const createCassaComuneRecord = function(destination) {
        destination.title = "t.app.profilo.ricarica.movimento.record.cassacomune";
        // destination.transferDescription = source.description;
        destination.transferDescription = $filter('translate')("t.app.profilo.ricarica.movimento.record.cassacomune");
        return destination;
      };
      const createPaghettaRecord = function(destination, source) {
        destination.title = "t.app.profilo.ricarica.movimento.record.paghetta";
        // destination.transferDescription = source.description || (source.contactName + " " + source.contactSurname);
        destination.transferDescription =  $filter('translate')("t.app.profilo.ricarica.movimento.record.paghetta.defaultDescription"); (source.contactName + " " + source.contactSurname);
        return destination;
      };
      const createCrowdfundingRecord = function(destination) {
        destination.title = "t.app.profilo.ricarica.movimento.record.crowdfunding";
        // destination.transferDescription = source.description;
        destination.transferDescription = $filter('translate')("t.app.profilo.ricarica.movimento.record.crowdfunding");
        return destination;
      };

      const createPagaRomanaRecord = function(destination, original) {
        destination.title = "t.app.profilo.ricarica.movimento.record.pagaromana.title";
        destination.transferDescription = destination.isIncome ?
          $filter('translate')("t.app.profilo.ricarica.movimento.record.pagaromana.incoming"):
          $filter('translate')("t.app.profilo.ricarica.movimento.record.pagaromana.outcoming");
        const contact = original.merchantInsignia && !(original.movementType === 'INCOMING' || original.movementType === 'INCOME')? ` ${original.merchantInsignia}` : ` ${original.contactName} ${original.contactSurname}`;
        destination.transferDescription = destination.transferDescription + contact;
        // destination.transferDescription = source.description || "t.app.profilo.ricarica.movimento.record.pagaromana.defaultDescription";
        return destination;
      };

      const createDefaultRecord = function(destination, source) {
        if (source.movementType.indexOf("INCOM")) {
          destination.title = "t.app.profilo.ricarica.movimento.record.default.titleIncome";
          destination.transferDescription = source.description || $filter('translate')("t.app.profilo.ricarica.movimento.record.default.descIncome");
        } else {
          destination.title = "t.app.profilo.ricarica.movimento.record.default.titleOutcome";
          destination.transferDescription = source.description || $filter('translate')("t.app.profilo.ricarica.movimento.record.default.descOutcome");
        }
        // WorkAround per togliere il codice operazione dai movimenti 'social'
        if (source.bankCausal === "AF") {
          destination.transferDescription = destination.transferDescription.split("Codice operazione")[0];
          destination.prefix = true;
        }
        return destination;
      };
      const service = {

        getInstrumentHistory: function(instrumentId) {

          return $q(function(resolve, reject) {

            const url = "wallet/getUserInstrumentP2PTransactions";

            const data = {
              "data": {
                "dtoReq": {
                  "dtoGetUserInstrumentP2PTransactionsReq": {
                    "userInstrumentId": instrumentId
                  }
                }
              },

              "userContext": {}

            };


            NewBackendService.invokeWebApiPost(url, data).then(
              function(data) {
                if (data.data.dtoRes.dtoGetUserInstrumentP2PTransactionsRes != null) {
                  let resultList = data.data.dtoRes.dtoGetUserInstrumentP2PTransactionsRes.p2pTransactionList;
                  // result list not undefined or null


                  if (resultList == null) {
                    resultList = [];
                  }

                  resolve(resultList);

                } else {
                  reject("null resultList");
                }
              },


              function(reason) {
                reject(reason);
              });
          });
        },


        getListaBonifici: function({
          pageIndex,
          dateFrom,
          dateTo,
          isInBackground
        }) {
          const url = "movimenti/getListaBonifici",
            data = {
              "userContext": {},
              "data": {
                "request": {
                  "getListaBonificiRequest": {
                    "pagination": {
                      "elementiPerPagina": pageIndex || DEFAULT_BANK_TRANSFER_PAGE_ELEMENTS,
                      "dataDa": dateFrom || moment().subtract(DEFAULT_DATE_FROM_DAYS_SUBTRACTION, 'days').format(DEFAULT_DATE_FILTER_FORMAT),
                      "dataA": dateTo || moment().format(DEFAULT_DATE_FILTER_FORMAT)
                    }
                  }
                }
              }
            };

          return $q(function(resolve, reject) {

            NewBackendService.invokeWebApiPost(url, data, isInBackground || true).then(function(data) {
              const resp = data.data.response.getListaBonificiResponse;

              // const url = '/src/main/www/datafiles/bonifici_storico.json';
              // JsonLoaderService.getJson(url).then(function(data) {

              //const resp = data;
              /*cancella fino a qui*/
              const
                pagination = resp.pagination || {},
                listaBonifici = resp.listaBonifici || [];
              if (angular.isArray(listaBonifici)) {
                // fetching data from server
                let output = []; //eslint-disable-line prefer-const
                _.each(listaBonifici, function(bonifico) { //eslint-disable-line prefer-const
                  output.push({
                    "transactionId": bonifico.transactionId,
                    "userwalletId": bonifico.userwalletId,
                    "userInstrumentId": bonifico.userInstrumentId,
                    "amount": parseInt(bonifico.amount),
                    "printableAmount": (parseInt(bonifico.amount) / 100).toFixed(2),
                    "currency": bonifico.currency,
                    "description": bonifico.description,
                    "iban": bonifico.iban,
                    "recipient": bonifico.recipient,
                    "debitDate": moment(bonifico.debitDate, DEFAULT_DATE_FILTER_FORMAT),
                    "dateunix": bonifico.debitDate,
                    "cro": bonifico.cro
                  });
                });
                resolve({
                  'listaBonifici': output,
                  'pagination': pagination
                });
              } else {
                $log.error("Malformed response from server");
                $log.error(data);
                reject(data);
              }
            }, function(error) {
              $log.error("Error in getListaBonifici");
              $log.error(error);
              reject(error);
            });
          });
        },

        /**
         * instrumentId: id dello strumento  [M]
         * pageIndex:  oggetto di indicizzazione (per la paginazione) [M]
         * elemPerPage, numero di elementi per ogni pagina [M]
         * idWalletMinore, in caso di parental control  [O]
         * filterOptionsParam  opzioni aggiuntive per il filtering. Per creare le options usare i metodi esposti dal servizio
         * paymentReason
         * onlyCSE
         */

        getTinabaPosHistory: function(filterOptionsParam) {
          const isSuperAdmin = StorageService.getLocalStorage('superAdmin');
          const userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
          console.log(userContext)
          const url = `${endPoints.userUrl}/wallet-transactions/business`;
          let filterOptions = filterOptionsParam;
          if(isSuperAdmin === "true"){
            filterOptions.walletId = userContext.walletId
          }
          return $q(function(resolve, reject) {
          
            NewBackendService.invokeWebApiGet(url, filterOptions, true).then(
              function(data) {
                console.log(data)
                if (data.data != "" && data.data._embedded && data.data._embedded.walletTransactions != null) {
                  let resultList = data.data._embedded.walletTransactions;
                  const pagination = data.data.page;
                  $log.debug("Pagination in service:", pagination);
                  if (resultList === undefined) {
                    resultList = [];
                  }
                  // il valore è in centesimi: lo normalizzo
                  angular.forEach(resultList, function(record) {
                    record.amount = record.amount / 100.0;
                    record.fee = (record.fee || 0) / 100.0;
                  });
                  const compositeObject = {
                    "resultList": resultList,
                    "pagination": pagination
                  };

                  $log.debug("compositeObject:", compositeObject);
                  resolve(compositeObject);

                } else {
                  resolve([]);
                }
              },


              function(reason) {
                reject(reason);
              });
          });
        },

        getTinabaInstrumentHistory: function(filterOptionsParam) {
          const isSuperAdmin = StorageService.getLocalStorage('superAdmin');
          const userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
          const url = `${endPoints.userUrl}/wallet-transactions`;
          let filterOptions = filterOptionsParam;
          if(isSuperAdmin === "true"){
            filterOptions.walletId = userContext.walletId
          }
          return $q(function(resolve, reject) {
          
            NewBackendService.invokeWebApiGet(url, filterOptions, true).then(
              function(data) {
                if(data.headers('sca_type') == scaTypeConstants.MOVEMENTS && isSuperAdmin !== "true"){
                  resolve( {
                    "resultList": [],
                    "pagination": {},
                    "scaType": true
                  })
                }else if (data.data != "" && data.data._embedded && data.data._embedded.walletTransactions != null) {
                  let resultList = data.data._embedded.walletTransactions;
                  const pagination = data.data.page;
                  $log.debug("Pagination in service:", pagination);
                  if (resultList === undefined) {
                    resultList = [];
                  }
                  // il valore è in centesimi: lo normalizzo
                  angular.forEach(resultList, function(record) {
                    record.amount = record.amount / 100.0;
                    record.fee = (record.fee || 0) / 100.0;
                  });
                  const compositeObject = {
                    "resultList": resultList,
                    "pagination": pagination,
                    "scaType": false
                  };

                  $log.debug("compositeObject:", compositeObject);
                  resolve(compositeObject);

                } else {
                  resolve( {
                    "resultList": [],
                    "pagination": {}
                  })
                }
              },


              function(reason) {
                reject(reason);
              });
          });
        },
        /*getTinabaInstrumentHistory: function(instrumentId, pageIndex, elemPerPage, idWalletMinore, filterOptionsParam, paymentReason) {

          let filterOptions = filterOptionsParam;
          return $q(function(resolve, reject) {
            const url = "movimenti/getListaMovimenti";
            //var data = {"data": {"dtoReq": {"dtoGetUserInstrumentP2PTransactionsReq": {"userInstrumentId": instrumentId}}},"userContext": {}};
            const data = {
              "userContext": {},
              "data": {
                "request": {
                  "getListaMovimentiRequest": {
                    "idStrumento": instrumentId,
                    "isInstrumentCard": false
                    // "cseOnly" : onlyCSE
                  }
                }
              }
            };
            const request = data.data.request.getListaMovimentiRequest;
            if (pageIndex !== undefined) {
              request.pagination = pageIndex;
            }

            if (idWalletMinore !== undefined) {
              request.idWalletMinore = idWalletMinore;
            }

            if (paymentReason !== undefined) {
              request.paymentReason = paymentReason;
            }

            if (filterOptions !== undefined) {
              $log.debug("getTinabaInstrumentHistory called with options");
              if (filterOptions.dataDa != undefined && filterOptions.dataA != undefined) {

                request.dataDa = filterOptions.dataDa;
                request.dataA = filterOptions.dataA;
              } else {
                $log.debug("Invalid date options: skip this filter");
              }

              if (filterOptions.isInstrumentCard) { // override with options
                request.isInstrumentCard = filterOptions.isInstrumentCard;
              }


              if (filterOptions.numeroTelefonoControparte) {
                request.numeroTelefonoControparte = filterOptions.numeroTelefonoControparte;
              }


              if (filterOptions.tipiMovimento) {
                request.tipiMovimento = filterOptions.tipiMovimento;
              }

              if (filterOptions.profileFilter) {
                request.profileFilter = filterOptions.profileFilter;
              }

              request.ignoreIdMerchantDevice = true;

            } else {
              filterOptions = {};
            }





            NewBackendService.invokeWebApiPost(url, data, filterOptions.isBackground || true).then(
              function(data) {
                if (data.data.response.getListaMovimentiResponse != null) {
                  let resultList = data.data.response.getListaMovimentiResponse.listaMovimenti;
                  const pagination = data.data.response.getListaMovimentiResponse.pagination;
                  $log.debug("Pagination in service:", pagination);
                  if (resultList === undefined) {
                    resultList = [];
                  }
                  // il valore è in centesimi: lo normalizzo
                  angular.forEach(resultList, function(record) {
                    record.amount = record.amount / 100.0;
                    record.fee = (record.fee || 0) / 100.0;
                  });
                  const compositeObject = {
                    "resultList": resultList,
                    "pagination": pagination
                  };

                  $log.debug("compositeObject:", compositeObject);
                  resolve(compositeObject);

                } else {
                  reject("null resultList");
                }
              },


              function(reason) {
                reject(reason);
              });
          });
        },*/

        /*
        walletMovementType:
        PROFILE_MERCHANT = 1,
        PROFILE_CONSUMER = 2,
        */
        getTinabaInstrumentHistoryNoCse: function(userInstrumentId, pageIndex, elemPerPage, idWalletMinore, filterOptionsParam, paymentReason, walletMovementType) {
          return $q(function(resolve, reject) {
            const data = {
              "data": {
                "dtoReq": {
                  "dtoGetWalletTransactionListReq": {
                    "idUserInstrument": userInstrumentId,
                    "paymentReason": paymentReason,
                    "walletMovementType": walletMovementType               
                  }
                }
              },
              "userContext": {}
            };
  
            const request = data.data.dtoReq.dtoGetWalletTransactionListReq;
            
            if (pageIndex || elemPerPage) {
              request.dtoPagination = {
                "elementPerPage": elemPerPage,
                "indexPage": pageIndex
              };
            }
  
            if (filterOptionsParam !== undefined) {
              if (filterOptionsParam.dataDa != undefined && filterOptionsParam.dataA != undefined) {
                request.dateFrom = filterOptionsParam.dataDa;
                request.dateTo = filterOptionsParam.dataA;
              } else {
                $log.debug("Invalid date options: skip this filter");
              }
  
              if (filterOptionsParam.tipiMovimento !== undefined) {
                request.transactionTypeList = {
                  'transactionType': filterOptionsParam.tipiMovimento
                }
                filterOptionsParam.tipiMovimento;
              }
            }
  
            NewBackendService.invokeWebApiPost('wallet/getWalletTransactionList', data, filterOptionsParam.isBackground).then(function(response) {
              if (response.data.dtoRes.dtoGetWalletTransactionListRes != null) {
                // il valore è in centesimi: lo normalizzo
                angular.forEach(response.data.dtoRes.dtoGetWalletTransactionListRes.dtoWalletTransactionFullList, function(record) {
                  record.amount = record.amount / 100.0;
                  record.fee = (record.fee || 0) / 100.0;
                  record.authTime = moment(record.authTime).valueOf();
                });
                resolve(response.data.dtoRes.dtoGetWalletTransactionListRes);
              } else {
                reject("null resultList");
              }
            }, function(error) {
              reject(error);
            });
          });
        },        


        createDefaultRangeOptions: function(numOfMonths, baseObj) {
          const opts = baseObj != null ? baseObj : {};
          var date = new Date();
          var fromDate = new Date(date.getFullYear(), date.getMonth()-(numOfMonths - 1), 1);;
          const toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          /*if (numOfMonths > 0) {
            fromDate = fromDate.subtract(numOfMonths - 1, 'months');
          } else {
            $log.debug("Invalid num of months: use 1 as default");
            fromDate = fromDate.subtract(0, 'months');
          }*/
          //non mostrare movimenti prima del 25 marzo
          if(fromDate < MOVEMENT_START_FROM_LIMIT){
            fromDate = MOVEMENT_START_FROM_LIMIT;
          }

          opts.dateStart = $filter('date')(fromDate, DEFAULT_DATE_FILTER_FORMAT); // estremo inferiore
          opts.dateEnd = $filter('date')(toDate, DEFAULT_DATE_FILTER_FORMAT); // estremo superiore
          return opts;
        },


        createBackgroundOptions: function(baseObj, value) {
          const opts = baseObj != null ? baseObj : {};
          opts.isBackground = value ? true : false;
          return opts;
        },


        createControparteOptions: function(baseObj, numeroTelefonoControparte) {
          const opts = baseObj != null ? baseObj : {};
          opts.numeroTelefonoControparte = numeroTelefonoControparte;
          return opts;
        },

        createTransactionModeOptions: function(baseObj, type) {
          const opts = baseObj != null ? baseObj : {};
          opts.tipiMovimento = type;
          return opts;
        },

        processRecordTitle: function(record, newRecord){

          return newRecord;
        },

        setDescriptionForSpecialMovements: function(record, newRecord){
          let prefix = undefined;
          if(record.description && record.description.indexOf('p2p')){
            record.paymentReason = service.getPaymentReasonFromRecord(record);
          }
          if ((record.paymentReason !== "p2p" && record.paymentReason !== undefined)/* || record.description.indexOf('p2p') !== -1*/) {
            prefix = record.paymentReason.substring(0, 2);
            newRecord.prefix = prefix;
            if (prefix === PREFIX_CASSACOMUNE) {
              newRecord = createCassaComuneRecord(newRecord, record);
            } else if (prefix === PREFIX_PAGHETTA) { // paghetta
              newRecord = createPaghettaRecord(newRecord, record);
            } else if (prefix === PREFIX_CROWDFUNDING) {
              newRecord = createCrowdfundingRecord(newRecord, record);
            } else if (prefix === PREFIX_ANTICIPO || prefix === PREFIX_UNLOCK_ANTICIPO) {
              newRecord = createAnticipoRecord(newRecord, record);
            } else if (prefix === PREFIX_PAGAROMANA) {
              newRecord = createPagaRomanaRecord(newRecord, record);
            }
          }

          return newRecord;
        },


        /**
         * setTitleDescriptionFromTransactionType - description
         *
         * @param  {type} record    description
         * @param  {type} newRecord description
         * @return {type}           description
         */
        setTitleDescriptionFromTransactionType : function(record, newRecord){
          switch (record.transactionType) {
            case 0: //ACCANTONAMENTO
              newRecord.title = "t.app.profilo.ricarica.movimento.accantonamento"; // non visibile da web
              break;
            case 1: //	RICARICA CONTO DA CARTA
              newRecord.title = "t.app.profilo.ricarica.movimento.ricaricadacarta";
              newRecord.transferDescription = $filter("translate")("t.app.profilo.ricarica.movimento.ricaricadacarta.description");
              break;
            case 2:
              newRecord.title = "t.app.profilo.ricarica.movimento.ricaricadabonifico";
              newRecord.transferDescription = $filter('translate')("t.app.profilo.ricarica.movimento.ricaricadabonificoBody");
              break;
            case 3: //	TRASFERIMENTO P2P
              const
                isIncome = record.movementType.indexOf('INCOM') !== -1;

              if (isIncome) {
                newRecord.title = $filter('translate')("t.app.profilo.ricarica.movimento.trasferimentoricevuto");
              } else {
                //bonifici?
                newRecord.title = $filter('translate')("t.app.profilo.ricarica.movimento.trasferimentoeffettuato");
              }
              if(record.contactName || record.merchantInsignia){
                const fromTo = isIncome ? "da" : "a";
                let contact = `${record.contactName} ${record.contactSurname}`;
                if(record.merchantInsignia && record.recipientType === 'MERCHANT' && !isIncome) {
                  contact = record.merchantInsignia;
                }
                newRecord.description = `${newRecord.title} ${fromTo} ${contact}`;
                newRecord.transferDescription = `${newRecord.title} ${fromTo} ${contact}`;
              }
              break;
            case 4: //RICARICA CONTO ESTERNO DA CONTO
              if (newRecord.transferDescription === BANK_TRANSFER_LABEL) {
                newRecord.title = "t.app.profilo.ricarica.movimento.bonifico";
                newRecord.transferDescription = $filter('translate')("t.app.profilo.ricarica.movimento.bonifico.body");
                //NOP
              } else {
                newRecord.title = "t.app.profilo.ricarica.movimento.ricaricadacontoesterno";
                newRecord.transferDescription = $filter('translate')("t.app.profilo.ricarica.movimento.ricaricadacontoesterno.body");
                //NOP
              }
              break;
            case 5: // ?? NON Definito
              //NOP
              break;
            case 6: //RICARICA CARTA DA CONTO
              newRecord.title = "t.app.profilo.ricarica.movimento.ricaricacartaDaConto";
              newRecord.transferDescription = $filter('translate')("t.app.profilo.ricarica.movimento.ricaricacartaDaContoBody");
              break;
            case 10:
              const isInc = record.movementType.indexOf('INCOM') !== -1;
                if (isInc) {
                  newRecord.title = $filter('translate')("t.app.profilo.ricarica.movimento.rimborsoricevuto");
                } else {
                  //bonifici?
                  newRecord.title = $filter('translate')("t.app.profilo.ricarica.movimento.rimborsoeffettuato");
                }
                if(record.contactName || record.merchantInsignia){
                  const fromTo = isInc ? "da" : "a";
                  let contact = `${record.contactName} ${record.contactSurname}`;
                  if(record.merchantInsignia && isInc) {
                    contact = record.merchantInsignia;
                  }
                  newRecord.description = `${newRecord.title} ${fromTo} ${contact}`;
                  newRecord.transferDescription = `${newRecord.title} ${fromTo} ${contact}`;
                }
              break;
            default:
              createDefaultRecord(newRecord, record);
              break;
          }
        },

        getPaymentReasonFromRecord : function(record){
          if(record.description && record.description.indexOf('idSocialGroup=') !== -1){
            const PAYMENT_REASON_FLAG = "idSocialGroup=";
            const index = record.description.indexOf(PAYMENT_REASON_FLAG);
            if(index !== -1){
              return record.description.slice(index + PAYMENT_REASON_FLAG.length, record.description.length);
            } else {
              return undefined;
            }
          }
        },
        /**
         * processWalletViewRecords - fetcher dei movimenti dell'app
         *
         * @param  {type} rawRecords         description
         * @param  {type} loadAvatar = false description
         * @return {type}                    description
         */
        processWalletViewRecords: function(rawRecords) {
          const processedRecords = [];
          if (rawRecords !== undefined && angular.isArray(rawRecords)) {
            _.each(rawRecords, function(record) {
              try {
                const newRecord = {};
                newRecord.paymentReason = record.paymentReason;// || getPaymentReasonFromRecord(record);

                // newRecord.transferDescription = record.description;
                newRecord.transactionType = record.transactionType;
                //gestione flag di income
                newRecord.isIncome = record.movementType.indexOf("INCOM") !== -1 ; //INCOMING, INCOME


                service.setTitleDescriptionFromTransactionType(record,newRecord);
                service.setDescriptionForSpecialMovements(record, newRecord);

                // gestione data
                //newRecord.date=moment(record.authTime).format("DD/MM/YYYY");
                newRecord.date = record.authTime;
                // gestione valore (gia normalizzato)
                newRecord.amount = record.amount;

                // GESTIONE da/a (web only)
                newRecord.fromTo = '';
                if (record.contactName) {
                    newRecord.fromTo = newRecord.fromTo + record.contactName;
                    if (record.contactSurname) {
                        newRecord.fromTo = newRecord.fromTo + ' ' + record.contactSurname;
                    }
                } else if (ACTIVATE_FROMTO_PARSER && record.description) {
                  // ho vergogna di quello che sto per scrivere
                  // Serve per i movimenti dopo il 28 aprile 2016 in dev, qualche giorno dopo in coll, per ora (12 05 2016) tutti in prod.
                  // M.Garza
                  const
                      flag = "a favore di ",
                      secondFlag = "disposto da ",
                      firstPosition = record.description.toLowerCase().indexOf(flag),
                      index_fromto = firstPosition !== -1 ? firstPosition : record.description.toLowerCase().indexOf(secondFlag);
                  if (index_fromto !== -1) {
                      let endDescription = 0;
                      if (record.description.indexOf(" nell'ambito") !== -1) {
                          endDescription = record.description.indexOf(" nell'ambito");
                      } else if (record.description.indexOf('BONIFIC') !== -1) {
                          endDescription = record.description.indexOf(" C.");
                      } else {
                          endDescription = record.description.indexOf(".");
                      }
                      newRecord.fromTo = record.description.substring(index_fromto + flag.length, endDescription).replace(/-/g, ' ').toLowerCase();
                  }
                }





                // if (loadAvatar) {
                //   getAvatarImage(record, prefix).then(function(avatar) {
                //     $log.debug("Retrive avatar: " + avatar);
                //     newRecord.avatar = avatar;
                //   }, function(reason) {
                //     $log.error(reason);
                //   });
                // }

                // push new record.
                processedRecords.push(newRecord);
              } catch (ex) {
                $log.error(ex);
              }
            });
          }
          return processedRecords;
        },

        /**
         * processContoViewRecords - fetcher dei movimenti specializzato per i movimenti di tipo conto su web
         *
         * @param  {{rawRecord}} rawRecords  dati grezzi da server
         * @return {{moviment}}             Dati parsati correttamente
         */
        processContoViewRecords : function(rawRecords) {
            const output = [];
            if (rawRecords !== null && angular.isArray(rawRecords)) {

                // that.processedRecord = NewInstrumentHistoryService.processWalletViewRecords(rawRecords);
                _.each(rawRecords, function(record) {
                    const newRecord = service.processContoViewSingleRecord(record);
                    output.push(newRecord);
                });

                // _.sortBy(that.processedRecord,function(obj){
                //   return obj.date;
                // });
            } else {
              $log.warn(`NewInstrumentHistoryService`,`processContoViewRecords`, `RawElements is not an array or is empty: ${rawRecords}`);
            }
            return output;
        },
        /**
         * processContoViewRecord - fetcher di un singolo movimento
         *
         * @param  {{record}} rawRecord  singolo dati grezzi da server
         * @return {{moviment}}             Dato
         */
        processContoViewSingleRecord : function(record) {
            let newRecord = {};
            newRecord.paymentReason = record.paymentReason || service.getPaymentReasonFromRecord(record);
            newRecord.description = record.description;
            //gestione flag di income
            newRecord.isIncome = (record.movementType.indexOf('INCOM') !== -1);
            //fetch del tipo di movimento
            service.setTitleDescriptionFromTransactionType(record,newRecord);
            newRecord = service.setDescriptionForSpecialMovements(record, newRecord);


            // fetch del mittente / destinatario
            newRecord.fromTo = '';
            if (record.contactName) {
                newRecord.fromTo = newRecord.fromTo + record.contactName;
                if (record.contactSurname) {
                    newRecord.fromTo = newRecord.fromTo + ' ' + record.contactSurname;
                }
            } else if (record.description && ACTIVATE_FROMTO_PARSER) {
              //FIXME workaround per trovare chi emette la transazione, dalla description
              // ho vergogna di quello che sto per scrivere (M.Garza). Deve funzionare per gli eventi precedenti il 28 aprile 2016 (dev) e poco dopo (coll). Sempre per prod (al 12 maggio 2016)
              const
                  flag = "a favore di ",
                  secondFlag = "disposto da ",
                  firstPosition = record.description.toLowerCase().indexOf(flag),
                  index_fromto = firstPosition !== -1 ? firstPosition : record.description.toLowerCase().indexOf(secondFlag);
              if (index_fromto !== -1) {
                  let endDescription = 0;
                  if (record.description.indexOf(" nell'ambito") !== -1) {
                      endDescription = record.description.indexOf(" nell'ambito");
                  } else if (record.description.indexOf('BONIFIC') !== -1) {
                      endDescription = record.description.indexOf(" C.");
                  } else {
                      endDescription = record.description.indexOf(".");
                  }
                  newRecord.fromTo = record.description.substring(index_fromto + flag.length, endDescription).replace(/-|_/g, ' ').toLowerCase();
              }
            }


            if(newRecord.prefix){
              newRecord.description = newRecord.transferDescription;
            }
            newRecord.date = record.authTime;
            newRecord.amount = record.amount;
            newRecord.transferDescription = newRecord.description;

            return newRecord;
        }
      };
      return service;
    }

export default instrumentHistoryFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/instrumentHistory.factory.js
 **/